(() => {
  const roots = () => document.querySelectorAll('[data-bea-nav]');
  const close = (root, restore = false) => {
    root.querySelectorAll('details[open]').forEach(detail => {
      detail.open = false;
      const trigger = detail.querySelector('summary');
      trigger.setAttribute('aria-expanded', 'false');
      if (restore) trigger.focus();
    });
  };
  const init = () => roots().forEach(root => {
    if (root.dataset.beaReady) return;
    root.dataset.beaReady = 'true';
    const desktop = root.classList.contains('BeaNav--desktop');
    root.querySelectorAll('details').forEach(detail => {
      const trigger = detail.querySelector('summary');
      let timer;
      detail.addEventListener('toggle', () => {
        trigger.setAttribute('aria-expanded', String(detail.open));
        if (detail.open) root.querySelectorAll('details[open]').forEach(other => {
          if (other !== detail) {
            other.open = false;
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
      });
      if (desktop) {
        detail.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(timer);
          detail.open = true;
        });
        detail.addEventListener('pointerleave', () => {
          timer = setTimeout(() => {
            if (!detail.contains(document.activeElement)) detail.open = false;
          }, 180);
        });
      }
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape' && root.querySelector('details[open]')) {
        event.preventDefault();
        event.stopPropagation();
        close(root, true);
      }
    });
    root.addEventListener('focusout', () => {
      if (desktop) setTimeout(() => {
        if (!root.contains(document.activeElement) && !root.matches(':hover')) close(root);
      }, 0);
    });
  });
  document.addEventListener('click', event => roots().forEach(root => {
    if (root.classList.contains('BeaNav--desktop') && !root.contains(event.target)) close(root);
  }));
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('resize', () => roots().forEach(root => {
    if (!root.getClientRects().length) close(root);
  }));
  init();
})();
